/* ============
 * Field Type Transformer
 * ============
 */

import Transformer from './transformer';

export default class FieldTypeTransformer extends Transformer {

  static fetch(model) {
    return {
      id: model.id,
      name: model.name,
      type: model.type,
    };
  }

  static send(model) {
    return {
      id: model.id,
      name: model.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/fieldType.js